import React from "react";
import Navbar from "../Components/Navbar";
import Portfolio from "../Components/Portfolio";

function PortfolioPage() {
  return (
    <>
      <Navbar />
      <Portfolio />
    </>
  );
}

export default PortfolioPage;
